export function orgInstrumentSelectOptions(joined, catalog, t) {
  const catalogById = Object.fromEntries(
    (catalog || []).map((instrument) => [String(instrument.id), instrument])
  );

  return (joined || []).map((row) => {
    const instrument =
      row.assessment_instrument ||
      catalogById[String(row.assessment_instrument_id)];
    const locked = !!instrument?.locked;
    const name = instrument?.name || String(row.assessment_instrument_id);
    return {
      value: String(row.assessment_instrument_id),
      label: locked ? name : `${name} (${t("unlocked")})`,
      disabled: !locked,
    };
  });
}
